// extracted by mini-css-extract-plugin
export default {"title":"ResetPasswordForm_title__NqmuP","form":"ResetPasswordForm_form__dyF7m","submit":"ResetPasswordForm_submit__ZLDMw"};